import { Column, ColumnBodyOptions } from 'primereact/column'
import classes from './PartiesMultipleValueTemplate.module.scss'
import { DataTable } from 'primereact/datatable'

interface PartiesMultipleValueTemplateProps {
  attribute: any
  values: any
  title: string
}

const PartiesMultipleValueTemplate = (props: PartiesMultipleValueTemplateProps) => {
  const renderColumnData = (data: any, options: ColumnBodyOptions) => {
    return (
      <span title={data} className={`${classes['table-cell-item__span']}`}>
        {data}
      </span>
    )
  }

  return (
    <div className={`${classes['parties-summary-table-container']}`} style={{ padding: '0rem' }}>
      <div className={`ul-grid__row`}>
        <div className={`ul-grid__column -x100`}>
          <DataTable
            removableSort
            value={props.values}
            dataKey="id"
            tableStyle={{
              position: 'relative',
              width: '100%',
            }}
            scrollHeight={props.values?.length > 10 ? '20rem' : ''}
            scrollable={props.values?.length > 10}
            style={{ border: '1px solid #dee2e6' }}
          >
            <Column
              body={renderColumnData}
              header={props.title}
              style={{ fontSize: 14 }}
              bodyStyle={{ display: 'table-cell' }}
              bodyClassName="text-container-ellipsis"
            />
          </DataTable>
        </div>
      </div>
    </div>
  )
}

export default PartiesMultipleValueTemplate
